// @ts-nocheck
import PropTypes from "prop-types";
import {useState} from "react";
import {BaseAvatar} from "@/components";
import {getUserAvatarImage, getUserInitials} from "../../util/avatarUtils";

const UserProfileAvatar = ({user, size = 100}) => {
  const [imageError, setImageError] = useState(false);
  const avatarImage = getUserAvatarImage(user);
  const userInitials = getUserInitials(user);

  const handleImageError = () => setImageError(true);

  return (
    <div style={{position: "relative", display: "inline-block"}}>
      <BaseAvatar size={size}>
        {!imageError && avatarImage ? (
          <img
            src={avatarImage}
            alt="User Avatar"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "50%",
            }}
            onError={handleImageError}
          />
        ) : (
          userInitials
        )}
      </BaseAvatar>
    </div>
  );
};

UserProfileAvatar.propTypes = {
  user: PropTypes.object,
  size: PropTypes.number,
  onUpload: PropTypes.func,
};

export default UserProfileAvatar;
